import { t } from "@lingui/macro"
import { I18n } from "@lingui/core"

import { AirClass, AirParams } from "@ssc-booking/api-contracts"

const getAirClassLabels = (): Record<AirClass, string> => ({
    Business: t`Business Class Air`,
    Economy: t`Economy Class Air`,
    EconomyPlus: t`Economy Plus Class Air`,
    First: t`First Class Air`,
})

export const airClassLabelFrom = (i18n_: I18n["_"]) =>
    AirParams.match({
        cruiseOnly: () => "",
        notAvailable: () => "",
        flight: ({ airClass }) => airClassLabel(i18n_, airClass),
    })

export const airClassLabel = (i18n_: I18n["_"], airClass: AirClass) => i18n_(getAirClassLabels()[airClass])
